import React from 'react';
import {OutputText} from '@ey/canvascoreservices';
import DocumentList from './DocumentList';
import StyledGroupInvolvement from './StyledGroupInvolvement';
import {currentResource} from '../../../../../../../../util/utils';

const GroupInvolvementIndex = ({...specialBodyProps}) => {
	const renderTitle = () => {
		const title = currentResource.labels.navGroupInvolvement;
		const outputTextProps = {size: 'XXL', title, className: 'section-header'};

		return <OutputText {...outputTextProps}>{title}</OutputText>;
	};

	const renderEntityList = () => {
		return <DocumentList {...specialBodyProps} />;
	};

	return (
		<StyledGroupInvolvement>
			{renderTitle()}
			{renderEntityList()}
		</StyledGroupInvolvement>
	);
};

//TODO: complete the default props.
GroupInvolvementIndex.propTypes = {};

//TODO: complete the props.
GroupInvolvementIndex.defaultProps = {};

export default GroupInvolvementIndex;
